export default {
  users: state => state.users,
  userRegions: state => state.userRegions,
  userPlaces: state => state.userPlaces,
  sortedUserPlaces: state => {
    const places = [...state.userPlaces]
    places.sort((a, b) => {
      return a.Id - b.Id
    })
    return places
  },
  userZones: state => state.userZones,
  filteredUsers(state, _, rootState) {
    if (rootState.app.searchString) {
      return state.users.filter(item => {
        return rootState.app.searchString
          .toLowerCase()
          .split(' ')
          .every(v => item.Name.toLowerCase().includes(v))
      })
    }
    return state.users
  },
  currentPageNumber: state => state.currentPageNumber,
  pageSize: state => state.pageSize,
  nextAvailablePage: state => state.nextAvailablePage
}
